$.urlParam = function(name){
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

  if (results==null) {
    return null;
  }
  return decodeURI(results[1]) || 0;
}

var baseDomain = window.partner.baseDomain;
var apiToken = getCookie('api_token');

var http = {
  baseUrl: [baseDomain, 'apps/api'].join('/'),
  sendReq: function(url, method, content) {
    var reqOpt = {
      type: method,
      url: [this.baseUrl, url].join('/'),
      headers: {
        'store_id': window.partner.storeId,
      },
      contentType: 'application/json; charset=utf-8',
      dataType: 'json'
    };

    if (method.toLowerCase() !== 'get')
      reqOpt['data'] = JSON.stringify(content);

    var def = $.Deferred();
    $.ajax(reqOpt).done(function (res) {
      def.resolve(res);
    }).fail(function (ex) {
      def.resolve(ex);
      console.log(ex);
    });

    return def.promise();
  },
  get: function (url) {
    return this.sendReq(url, 'get');
  },
  post: function (url, content) {
    return this.sendReq(url, 'post', content);
  },
  put: function (url, content) {
    return this.sendReq(url, 'put', content);
  },
  delete: function (url, content) {
    return this.sendReq(url, 'delete', content);
  }
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');

  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function setCookie(cname, cvalue, expiration, typeEx) {
  const d = new Date()
  if (typeEx === 'second') {
    d.setTime(expiration * 1000);
  } else if (typeEx === 'day') {
    d.setTime(d.getTime() + (expiration * 24 * 60 * 60 * 1000));
  }
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


function getOMSAccessToken() {
  const omsAccessTocken = getCookie('oms_access_token');

  if(!omsAccessTocken) {
    const apiRequest = new ApiFetch(true);

    return apiRequest.fetcher('oms-token')
      .then((res) => {
        if(!res) return Promise.reject(new Error("Cannot get access token"));

        setCookie('oms_access_token', res.access_token, (res.expires_in - 600)/60/60/24, 'day');

        return res.access_token;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }
  else {
    return Promise.resolve(omsAccessTocken);
  }
}

async function callAPIWithTokenRefresh (url, method, content) {
  try {
    const response = await http.sendReq(url, method, content);
    return response;
  } catch (ex) {
    if (ex.status === 401) {
      // Token expired, refresh the token
      try {
        // Retry the API call with the new token
        return await http.sendReq(url, method, content);
      } catch (err) {
        console.log(err);
        throw err; // Token refresh failed
      }
    } else {
      throw ex; // Other API call failure
    }
  }
}

class ApiFetch {
  static #methods = {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
    DELETE: 'delete'
  };
  static #baseUrl = window.partner.uatPdpApi;
  static #appPartnerAPIDomain = window.partner.appPartnerAPIDomain;

  _isAppPartner = false;

  /**
   * @param {boolean} [isAppPartner] - Whether the API is for an app partner
   * */
  constructor (isAppPartner = false) {
    this._isAppPartner = isAppPartner;
  }

  /**
   * Reusable ajax request
   * @param {string} url - API endpoint url
   * @param {'get'|'post'|'put'|'delete'} method - HTTP method
   * @param {any} body - Request body
   * @param {object} options - Additional options for the ajax request
   * @returns {Promise<any>} - Promise object with the response data
   * */
  #ajaxRequest (url, method = ApiFetch.#methods.GET, body = null, options = {}) {
    const baseUrl = this._isAppPartner ? ApiFetch.#appPartnerAPIDomain : ApiFetch.#baseUrl;
    return $.ajax({
      type: method,
      url: `${baseUrl}/${url}`,
      headers: {
        'Accept-Language': 'en-US',
        'store_id': window.partner.storeId,
        'ocp-apim-subscription-key': window.partner.uatPdpApiSubscriptionKey
      },
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      Accept: '*/*',
      xhrFields: {
        withCredentials: true
      },
      ...(body ? { data: JSON.stringify(body) } : {}),
      ...options
    });
  }

  /**
   * @param {string} url - API endpoint url
   * @returns {Promise<any>} - Promise object with the response data */
  fetcher(url) {
    return this.#ajaxRequest(url, ApiFetch.#methods.GET);
  }

  /**
   * @param {string} url - API endpoint url
   * @param {any} body - Request body
   * @returns {Promise<any>} - Promise object with the response data */
  post (url, body) {
    return this.#ajaxRequest(url, ApiFetch.#methods.POST, body);
  }

  /**
   * @param {string} url - API endpoint url
   * @param {any} body - Request body
   * @returns {Promise<any>} - Promise object with the response data */
  put (url, body) {
    return this.#ajaxRequest(url, ApiFetch.#methods.PUT, body);
  }

  /**
   * @param {string} url - API endpoint url
   * @param {any} body - Request body
   * @returns {Promise<any>} - Promise object with the response data */
  delete(url, body) {
    return this.#ajaxRequest(url, ApiFetch.#methods.DELETE, body);
  }
}

window.getOMSAccessToken = getOMSAccessToken;